import { swRequest } from "./sw-request";

export const getCandidate = (candidateId, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/get",
      method: "GET",
      params: { candidateId },
    },
    opts,
  );

export const saveCandidate = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/save",
      method: "POST",
      body,
    },
    opts,
  );

export const modifyCandidates = (body) =>
  swRequest({
    path: "/api/candidates/modify",
    method: "POST",
    body,
  });

export const startSearches = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/start_searches",
      method: "POST",
      body,
    },
    opts,
  );

export const getSearches = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/get_searches",
      method: "POST",
      body,
    },
    opts,
  );
